import { Culture } from '../../types';

export const spokane: Culture = {
  name: 'Spokane',
  languageFamily: 'Salishan',
  terms: [
    {
      word: 'Smiyúuł',
      phonetic: 'smee-yool',
      description: 'Spokane word meaning "hello."'
    },
    {
      word: 'Qép',
      phonetic: 'kep',
      description: 'Spokane word for "water."'
    },
    {
      word: 'Šey',
      phonetic: 'shay',
      description: 'Spokane term for "sky."'
    },
    {
      word: 'Twk’wé',
      phonetic: 'twk-weh',
      description: 'Spokane word meaning "star."'
    },
    {
      word: 'Sqélixʷ',
      phonetic: 'sqeh-leek',
      description: 'Spokane term meaning "the people."'
    }
  ]
};